export const API_URL = "https://api.vipmanor.com";
export const LAMBDA_API_URL = "https://lambda.vipmanor.com";
